export default __webpack_public_path__ + "static/media/ReactRajTechWeb.9fdf1e5d.png";